import { useCustomFieldsForRole } from '@/hooks/useCustomFieldsForRole';
import { useMemo } from 'react';

const useGetProjectFieldsets = () => {
  const { customFields: projectCustomFields, ...rest } =
    useCustomFieldsForRole('project');

  const projectFieldsets = useMemo(
    () => projectCustomFields.filter((field) => field.type === 'fieldset'),
    [projectCustomFields]
  );

  return {
    projectFieldsets,
    ...rest,
  };
};

export default useGetProjectFieldsets;
